export const environment = {
  stage: false,
  canary: true,
  test: false,
  localhost: false,
  production: false,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts